<template>
<div>
    <div class="container-fluid mt--6 filter-show">
        <div class="card w-100 p-2 mb-2  d-inline-block">
      <div class="d-flex justify-content-between">
         <h5 class="ml-3">Filters</h5>
         <span class="btn btn-link" @click="showFilters = !showFilters">
         <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
         </span>
      </div>
      <div class="row" v-if="showFilters">
         <div class="col-lg-12">
            <form class="row">
               <div class="col-md-4 col-lg-4">
                  <label for="filter" class="col-form-label">Status</label>
                   <multiselect 
                      v-model="filterStatus" 
                      placeholder="Select" 
                      label="name" 
                      track-by="value" 
                      :options="statusList" 
                      :multiple="true" 
                      :limit="4"  >
                      <template slot="option" slot-scope="{ option }">
                        <span :title="option.description">{{ option.name }}</span>
                    </template>
                  </multiselect>
               </div>
               <div class="col-md-6 col-lg-4">
                  <label for="filter" class="col-form-label">Accounts</label>
                  <multiselect 
                    v-model="filterAccounts" 
                    placeholder="Select" 
                    :options="accountList"  
                    :multiple="true" 
                    :limit="3"  ></multiselect>
                </div>
               <div class="col-md-6 col-lg-3 mt-2">
                  <button @click="clearFilter()" type="button" class="btn btn-secondary rounded">Clear</button>
                  <button @click="filterHolding()" type="button" class="btn btn-primary rounded">Filter</button>
               </div>
            </form>
         </div>
      </div>
        </div>
  </div>
  <div class="container-fluid">

    <div class="abs-btn-grp form-group col-sm-4">
      <div v-if="selectedCount > 0" class="selection-chip align-self-center mr-2">
        <span class="selection-chip__count">Selected: {{ selectedCount }}</span>
        <button @click="clearSelection()" type="button" class="selection-chip__clear" title="Clear selection">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <!-- Table Search -->
      <form  @submit.prevent="" class="d-inline-flex mt-0 ml-4">
        <i @click="searchHolding()" data-v-d13f7de6="" aria-hidden="true" class="fas fa-search active cursor-pointer"></i>
        <input v-on:keyup.enter="searchHolding" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)"  data-v-d13f7de6="" type="text" placeholder="Search Here" aria-label="Search" class="form-control form-control-sm ml-3 mr-3">
        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
      
      </form>

      <Button type="button" @click="swapHoldings" class="btn btn-warning"><i class="fas fa-cloud-download-alt"></i> SWAP</Button>
    </div>
      <div class="row xsOnly">
        <div class="col-xl-12">
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive">
                  <table class="table align-items-center table-flush table-hover bidtbl bid-acc">
                      <thead class="thead-light psticky">
                        <tr >
                          <th 
                          scope="col" 
                          class="text-center"
                          >SELECT</th>
                          <th 
                          scope="col" 
                          class="sort text-left"
                          >CUSTOMER | ACCOUNT</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusipVal'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusipVal'  ? 'sort-desc' : '']"  
                          @click="sort('cusipVal')">CUSIP/DESC</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'coupon'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'coupon'  ? 'sort-desc' : '']"  
                          @click="sort('coupon')">COUPON</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturityDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturityDate'  ? 'sort-desc' : '']"  
                          @click="sort('maturityDate')">MATURITY DATE/<br>CALL DATE</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'ratingMoody'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'ratingMoody'  ? 'sort-desc' : '']"  
                          @click="sort('ratingMoody')"
                          >MOODY'S/ <br>S&P RATING</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bondInsurer'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bondInsurer'  ? 'sort-desc' : '']"  
                          @click="sort('bondInsurer')"
                          >INSURER</th>
                          <!-- <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'boughtDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'boughtDate'  ? 'sort-desc' : '']"  
                          @click="sort('boughtDate')"
                          >BOUGHT</th> -->
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cost'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cost'  ? 'sort-desc' : '']"  
                          @click="sort('cost')"
                          >COST/ <br>SELL QTY</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'costYtm'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'costYtm'  ? 'sort-desc' : '']"  
                          @click="sort('costYtm')"
                          >YTM/ <br>YTC</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'closingPx'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'closingPx'  ? 'sort-desc' : '']"  
                          @click="sort('closingPx')"
                          >CLOSING PX</th>
                          <th 
                          scope="col" 
                          class="sort text-left"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'pl'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'pl'  ? 'sort-desc' : '']"  
                          @click="sort('pl')"
                          >HIGHEST BID</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'spread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'spread'  ? 'sort-desc' : '']"  
                          @click="sort('spread')"
                          >SPREAD</th> 
                          
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'expireTime'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'expireTime'  ? 'sort-desc' : '']"  
                          @click="sort('expireTime')"
                          >VALID / <br>FIRM UNTIL TIME</th>
                         
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'traderName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'traderName'  ? 'sort-desc' : '']"  
                          @click="sort('traderName')"
                          >TRADER/ADMIN</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'operatorName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'operatorName'  ? 'sort-desc' : '']"  
                          @click="sort('operatorName')"
                          >OPERATOR</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          >STATUS</th> 
                           <th 
                          scope="col" 
                          class="sort text-center"
                          >HOLDINGS</th> 
                          <th 
                          scope="col" 
                          class="sort text-center"
                          >ACTION</th>
                        </tr>
                      </thead>
                      <tbody class="list">
                      <tr v-if="totalRows == 0 && !loading">
                          <td><p class="nodata">No data available</p>
                          </td>
                      </tr>
                      <tr v-for="holding in holdingsList" :key="holding.selectionKey"  >
                        <td class="text-center"  >
                          <input v-if="holding.highestBids.length > 0"  v-model="holding.isSelect" @change="selectHolding(holding)" type="checkbox" class="form-check-input cursor-pointer" />
                        </td>
                        <td class="text-left">
                          <div v-for="customer in holding.bidWantedInventoryListDtoAccount"  :key="customer.id">
                            <span class="text-primary">{{customer.customerFirstName ? customer.customerFirstName[0] : ""}} {{customer.customerLastName}}</span>
                            | <span class="text-success">{{customer.accountVal}}</span> 
                          </div>
                        </td>
                        <td class="text-center">
                            <span class="cusips">{{holding.cusipVal}}</span><br>
                            <span data-toggle="tooltip" data-placement="left"  v-bind:title='holding.cusipDescription'>{{holding.cusipDescription | truncate(20, '...')}}</span>
                        </td>
                        <td class="text-center"><span>{{holding.coupon |  percent(3) }}</span></td>
                        <td class="text-center">
                          <span class="maturity">{{holding.maturityDate ? moment(holding.maturityDate).format("MM/DD/YYYY") : "N/A"}}</span><br>
                        {{holding.callDate ? moment(holding.callDate).format("MM/DD/YYYY") : "N/A"}}
                        </td>
                        <td class="text-center"><span class="text-primary">{{holding.ratingMoody ? holding.ratingMoody : "N/A"}}</span>
                            <span class="insurer text-success">{{holding.ratingSP ? holding.ratingSP : "N/A"}}</span>
                        </td>
                        <td class="text-center"><span class="insurer">{{holding.bondInsurer ? holding.bondInsurer : "N/A"}}</span></td>
                        <!-- <td class="text-center">
                            <span>{{holding.boughtDate ? moment(holding.boughtDate).format("MM/DD/YYYY") : 'N/A'}}</span>
                        </td> -->
                         <td class="text-center">
                            <span class="text-success">{{holding.cost | currency}}</span><br>
                            <span>{{holding.sellQuantity}}</span>
                        </td>
                        <td class="text-center">
                            <span class="text-success">{{holding.costYtm}}%</span><br>
                            <span>{{holding.costYtc}}%</span>
                        </td>
                       
                        <td class="text-center">
                            <span class="text-danger">{{holding.closingPx}}</span><br>
                        </td>
                         
                        <td class="text-left">
                          <!-- <div v-if="holding.highBidId">
                            <div class="d-block mr-3 mt-2 mb-2"><span class="d-inline-block">Price: </span><span class="text-primary border rounded border-primary px-2 ml-1 ml-2 mb-2 mt-1 d-inline-block">{{holding.highBidPrice}}</span></div>
                            <div class="d-block mr-3 mt-2 mb-2"><span class="d-inline-block">Spread: </span><span v-bind:class="[(holding.highBidPrice - holding.cost).toFixed(2) > 0 ? 'text-success border-success' : 'text-danger border-danger']" class=" border rounded px-2 mt-1 ml-2 d-inline-block">{{(holding.highBidPrice - holding.cost).toFixed(2)}}</span></div>
                            <div class="d-block mr-3 mt-2 mb-2"><span class="d-inline-block">P&L: </span> <span v-bind:class="[((holding.highBidPrice - holding.cost).toFixed(2) * holding.sellQuantity * 10).toFixed(2) > 0 ? 'text-success border-success' : 'text-danger border-danger']" class="border rounded px-2 mt-1 ml-2 d-inline-block">{{((holding.highBidPrice - holding.cost).toFixed(2) * holding.sellQuantity * 10).toFixed(2)}}</span></div>
                            <div class="mt-3" >
                              <div class="high-bid">
                                <span class="text-success">{{holding.highBidEcn}}</span>
                                <span><a v-if="holding.status == 'AUTHORIZED' || holding.status == 'WAITING_AUTHORIZATION' || holding.status == 'BID_RECEIVED' || (holding.status == 'REJECTED')" href="javascript:void(0);" @click="acceptBid(holding.highBidId)" class="ml-3 btn-link">Accept</a></span>
                              </div>
                            </div>
                          </div> -->
                          <div v-if="holding.highestBids.length > 0">
                            <div class="d-block mr-3 mt-2 mb-2"><span class="d-inline-block">Price: </span><span class="text-primary border rounded border-primary px-2 ml-1 ml-2 mb-2 mt-1 d-inline-block">{{holding.highestBids[0].bidPrice}}</span></div>
                            <div class="d-block mr-3 mt-2 mb-2"><span class="d-inline-block">Spread: </span><span v-bind:class="[(holding.highestBids[0].bidPrice - holding.cost).toFixed(2) > 0 ? 'text-success border-success' : 'text-danger border-danger']" class=" border rounded px-2 mt-1 ml-2 d-inline-block">{{(holding.highestBids[0].bidPrice - holding.cost).toFixed(2)}}</span></div>
                            <div class="d-block mr-3 mt-2 mb-2"><span class="d-inline-block">P&L: </span> <span v-bind:class="[((holding.highestBids[0].bidPrice - holding.cost).toFixed(2) * holding.sellQuantity * 10).toFixed(2) > 0 ? 'text-success border-success' : 'text-danger border-danger']" class="border rounded px-2 mt-1 ml-2 d-inline-block">{{((holding.highestBids[0].bidPrice - holding.cost).toFixed(2) * holding.sellQuantity * 10).toFixed(2)}}</span></div>
                            <div class="d-block mr-3 mt-2 mb-2">
                              <span class="d-inline-block"> Yield: </span>
                              <span  class="border rounded px-2 mt-1 ml-2 d-inline-block">{{ holding.highBidYield }}</span>
                            </div>
                            <div class="mt-3" >
                              <div class="high-bid" v-for="bid in holding.highestBids" :key="bid.id">
                                <span class="text-success">{{bid.ecn}}</span>
                                <span><a v-if="holding.status == 'AUTHORIZED' || holding.status == 'WAITING_AUTHORIZATION' || holding.status == 'BID_RECEIVED' || (holding.status == 'REJECTED')" href="javascript:void(0);" @click="acceptBid(bid.id)" class="ml-3 btn-link">Accept</a></span>
                              </div>
                            </div>
                          </div>
                          <div v-if="holding.highestBids.length == 0">
                            N/A
                          </div>
                        </td>
                        <td class="text-center">
                            <template v-if="holding.status == 'WAITING_AUTHORIZATION'">
                              <span>
                                <div v-for="cust in holding.bidWantedInventoryListDtoCopy"  :key="cust.id" style="display:flex">
                                  <span class="text-primary">{{cust.customerFirstName ? cust.customerFirstName[0] : ""}} {{cust.customerLastName}}</span>
                                  <input style="margin-top:-5px;margin-left:5px;" type="number" class="form-control" placeholder="Spread"  v-model.number="cust.spread">
                                </div>
                              </span>
                            </template>
                            <template v-else>
                              <span class="sell-qty" v-for="cust in holding.bidWantedInventoryListDtoCopy"  :key="cust.id" >
                                <div>
                                  <span class="text-primary">{{cust.customerFirstName ? cust.customerFirstName[0] : ""}} {{cust.customerLastName}}</span>
                                  : <span >{{cust.spread ? cust.spread.toFixed(3) : "N/A"}}</span>
                                </div>
                              </span>
                            </template>
                        </td> 
                       
                        <td class="text-center">
                          <span>{{holding.expireTime ? moment.utc(holding.expireTime).local().format("hh:mm:ss a") : 'N/A'}}</span> <br>
                          <span>{{holding.firmUntilDate ? moment.utc(holding.firmUntilDate).local().format("hh:mm:ss a") : 'N/A'}}</span>
                        </td> 
                      
                        <td class="text-center">
                          <span>{{holding.traderFirstName}} {{holding.traderLastName}}</span><br>
                        </td>
                        <td class="text-center">
                          <span>{{holding.operatorFirstName}} {{holding.operatorLastName}}</span>
                        </td>   
                         <td class="text-center"><span>{{holding.status}}</span></td>
                          <td class="text-center">
                          <a @click="toggleViewHoldingModalOpen(holding.bidWantedInventoryListDto)" class="btn ibtn btn-outline-primary mb-2" title="Holding"><i class="far fa-user mb-2"></i></a>
                        </td> 
                        <td class="text-right invt">
                          <button v-if="holding.status == 'WAITING_AUTHORIZATION'"  @click="acceptAuth(holding);" type="button" class="btn btn-success mb-2" >AUTHORIZE</button>
                          <button v-if="holding.status == 'AUTHORIZED' || holding.status == 'BRING_IN'"  @click="rejectAuth(holding);" type="button" class="btn btn-danger mb-2" >UNAUTHORIZE</button>
                          <!-- <button @click="toggleViewBidWantedModalOpen(holding);selectedHolding = holding" type="button" class="btn btn-primary mb-2" >BIDS</button> -->
                          <button v-if="holding.status == 'WAITING_AUTHORIZATION'"  @click="toggleBringInBidWantedModal(holding)" type="button" class="btn btn-warning mb-2" >BRING IN</button>
                          <button v-if="holding.status == 'BID_RECEIVED' || (holding.status == 'REJECTED' && holding.highestBids.length > 0)"  @click="toggleExecuteBidWantedModalOpen(holding);selectedHolding = holding" type="button" class="btn btn-warning mb-2" >BRING FOR INV</button>
                          <!-- <a  @click="deleteBidWanted(holding)" class="btn ibtn btn-outline-danger mb-2"><i class="fas fa-trash-alt mb-2"></i></a> -->
                          <!-- <button v-if="holding.highestBids.length > 0" @click="toggleSwapModalOpen(holding);selectedHolding = holding" type="button" class="btn btn-info mb-2" >SWAP</button> -->
                          
                          <div class="d-inline-flex">
                                 <div class="dropdown">
                                    <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                       <button v-if="holding.highestBids.length > 0" type="button" @click="toggleSwapModalOpen(holding);selectedHolding = holding"  class="dropdown-item" title="SWAP">
                                          <span class="fas fa-exchange-alt mr-1"></span> <div>SWAP</div>
                                        </button>
                                        <button type="button"  @click="deleteBidWanted(holding)" class="dropdown-item" title="Delete">
                                          <span class="fa fa-trash mr-1"></span> <div>DELETE</div>
                                        </button>
                                        <button type="button"  @click="toggleViewBidWantedModalOpen(holding);selectedHolding = holding" class="dropdown-item" title="Delete">
                                          <span class="fas fa-database mr-1"></span> <div>BIDS</div>
                                        </button>
                                    </div>
                                 </div>
                              </div>

                        </td>
                        </tr>
                      </tbody>
                      <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                  </table>
                  <!-- Pagination-->
                  <b-pagination
                      class="mt-4"
                      :total-rows="totalRows"
                      v-model="currentPage"
                      :per-page="perPage"
                      @input="getHoldingList(true)"
                  ></b-pagination>
                  <div class="total-records">
                      <span>Total Records : {{totalRows}}</span>
                  </div>
            </div>
          </div>
        </div>
      </div>
      <ExecuteBidWanted v-bind:holding="selectedHolding" v-if="viewExecuteBidWantedModalOpen" @close="toggleExecuteBidWantedModalOpen()"/>
      <BringInBidWanted v-bind:holding="selectedHolding" v-if="viewBringInModalOpen" @close="toggleBringInBidWantedModal()" />
      <ViewBidWanted v-bind:holding="selectedHolding" v-bind:role="'TRADER'" v-if="viewBidWantedModalOpen" @close="toggleViewBidWantedModalOpen()" />
      <ViewHoldings  v-bind:holding="holdingsInBidWanted" v-if="viewHoldingModalOpen" @close="toggleViewHoldingModalOpen()" />
      <SwapModal  v-bind:selectedBidWanteds="selectedBidWanteds" v-if="viewSwapModalOpen" @close="toggleSwapModalOpen()"  />
  </div> 
</div>     

</template>
<script>
import config from "@/config";
import authService from "@/authService";
import ViewBidWanted from '../../ba-common/BaViewBidWantedModal.vue';
import BringInBidWanted from '../../ba-common/BaBringBidWantedModal.vue';
import ExecuteBidWanted from '../../ba-common/BaExecuteBidWanted.vue';
import ViewHoldings from '../../ba-common/BaViewHoldingListModal';
import SwapModal from '../../ba-common/BaSwapBidWantedModal';

// import Datepicker from 'vuejs-datepicker';

export default {
  name: "baAllHoldingsTrader",
  components : {
    ViewBidWanted,
    BringInBidWanted,
    ExecuteBidWanted,
    ViewHoldings,
    SwapModal
  },
  data() {
    return {
        loading : false,
        currentPage: 1,
        perPage: 20,
        searchValue : "",
        sortColumn: "pl",
        sortOrder:"DESC",
        totalRows : 0,
        viewBidWantedModalOpen : false,
        holdingsList : [],
        selectedHolding : null,
        cognitoSub : authService.getUser().cognitoSub,
        bidWantedStatus : 'ALL',
        statusList :  [
                       { name: 'Send to ecn', value:'ECN_SENT',description :'' },
                       { name: 'Received', value: 'BID_RECEIVED',description :'' },
                       { name: 'Accepted', value: 'BID_ACCEPTED',description :''},
                       { name: 'Waiting Auth', value: 'WAITING_AUTHORIZATION',description :''},
                       { name: 'Authorized', value: 'AUTHORIZED',description :''},
                       { name: 'Rejected', value: 'REJECTED',description :''},
                       { name: 'New Order Initiated', value: 'NEW_ORDER_INITIATED',description :''},
                       { name: 'Bring In', value: 'BRING_IN',description :''},
                       { name: 'Bid Cancelled', value: 'AUTHORIZED_BID_CANCELLED',description :''}


                       ],
        filterStatus : [],
        showFilters : false,
        accountList : [],
        filterAccounts : [],
        viewBringInModalOpen : false,
        viewExecuteBidWantedModalOpen : false,
        viewHoldingModalOpen : false,
        holdingsInBidWanted : [],
        viewSwapModalOpen : false,
        selectedBidWanteds : [],
        selectedHoldingsMap : {},

    };
  },
  computed: {
    selectedCount(){
      return Object.keys(this.selectedHoldingsMap).length;
    }
  },
  methods: {
    selectionKey(holding, index){
      return holding.id !== undefined && holding.id !== null ? "id-" + holding.id : "row-" + this.currentPage + "-" + index;
    },
    selectHolding(holding){
      if(holding.isSelect){
        let selectedHoldings = Object.values(this.selectedHoldingsMap);
        // Ensure the newly selected holding belongs to the same account as the already selected ones.
        if(selectedHoldings.length > 0 && holding.bidWantedInventoryListDtoAccount[0].accountVal != selectedHoldings[0].bidWantedInventoryListDtoAccount[0].accountVal){
          this.$alert("Please select holdings from same account.","","warning");
          // Revert on the next tick so Vue re-renders the checkbox back to unchecked
          this.$nextTick(() => {
            holding.isSelect = false;
          });
          return;
        }
        this.$set(this.selectedHoldingsMap, holding.selectionKey, holding);
      }else{
        this.$delete(this.selectedHoldingsMap, holding.selectionKey);
      }
    },
    clearSelection(){
      this.selectedHoldingsMap = {};
      this.holdingsList.forEach(holding => {
        holding.isSelect = false;
      });
    },
    // Keeps the checkboxes of previously selected rows ticked when a page is revisited.
    retainSelection(holdings){
      holdings.forEach((holding, index) => {
        holding.selectionKey = this.selectionKey(holding, index);
        if(this.selectedHoldingsMap[holding.selectionKey]){
          holding.isSelect = true;
          this.selectedHoldingsMap[holding.selectionKey] = holding;
        }
      });
    },
    swapHoldings(){
        let selectedHoldings = Object.values(this.selectedHoldingsMap);
        console.log("selectedHoldings",selectedHoldings);
         //check bidWantedInventoryListDto[0].accountVal from selectedHoldings should be same in all selected holdings.
        if(selectedHoldings.length == 0){
          this.$alert("Please select holdings to swap.","","warning");
          return false;
        }
        let accountsMatch = true;
        selectedHoldings.forEach(holding => {
          if(holding.bidWantedInventoryListDtoAccount[0].accountVal != selectedHoldings[0].bidWantedInventoryListDtoAccount[0].accountVal){
            this.$alert("Please select holdings from same account.","","warning");
            accountsMatch = false;
          }
        });
        if (!accountsMatch) {
          return false;
        }
        this.selectedBidWanteds = selectedHoldings;
        this.viewSwapModalOpen = !this.viewSwapModalOpen;


    },
    toggleSwapModalOpen(selectedHoldings){
        this.selectedBidWanteds = [selectedHoldings];
        this.viewSwapModalOpen = !this.viewSwapModalOpen;
      },
      toggleViewHoldingModalOpen(holdings){
        this.holdingsInBidWanted = holdings
        this.viewHoldingModalOpen = !this.viewHoldingModalOpen;
      },
      toggleExecuteBidWantedModalOpen(){
        this.viewExecuteBidWantedModalOpen = !this.viewExecuteBidWantedModalOpen;
        if(!this.viewExecuteBidWantedModalOpen){
          this.getHoldingList();
        }
      },
      sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getHoldingList(true);
      },
      acceptBid(highBidId){
        var message = "Are you sure you want to accept this bid?";
        this.$confirm(message,"","question").then(() => {
            this.loader = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            let data = {
                "bidWantedBidId": highBidId,
                "cognitoSub": authService.getUser().cognitoSub
            }
            this.$http
            .post(config.baseUrlBidSide + "/bidwanted/accept",data,auth)
            .then(() => {
                this.loading = false;             
                this.$alert("The bid has been successfully accepted.","","success");
                this.getHoldingList(); 
                 
            })
            .catch(() => {
                this.loading = false;              
            });
        })
      },
      deleteBidWanted(holding){
        var message = `Are you sure you want to delete this bid wanted?`;
        this.$confirm(message,"Delete Bid Wanted","warning",{confirmButtonText:"DELETE",cancelButtonText : "NO"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          
          this.$http
          .put(config.baseUrlBidSide + "/bidwanted/delete?bidWantedId="+holding.id,'',auth)
          .then(() => {
              this.loading = false; 
              this.getHoldingList();             
              this.$alert("Bid Wanted has been successfully deleted.","","success")
          })
          .catch(() => {
              this.loading = false;              
          });
      })
      },
      acceptAuth(holding){
        var message = `Do you want to authorize the high bid for trade?`;
        this.$confirm(message,"Accept authorization","info",{confirmButtonText:"ACCEPT",cancelButtonText : "NO"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let spreadDto = [];
          holding.bidWantedInventoryListDtoCopy.forEach(customer => {
            spreadDto.push({customerId : customer.customerId, spread : customer.spread})
          })
          let data = {
              "bidWantedId": holding.id,
              "status" : 'AUTHORIZED',
              "cognitoSub":authService.getUser().cognitoSub,
              "spread":spreadDto,
              "highBidIds": holding.highBidId

          }
          this.$http
          .post(config.baseUrlBidSide + "/bidwanted/authorize",data,auth)
          .then(() => {
              this.loading = false; 
              this.getHoldingList();             
              // this.$alert("Holding has been successfully assigned to you.","","success")
          })
          .catch(() => {
              this.loading = false;              
          });
      })

    },
    rejectAuth(holding){
        var message = `Do you want to unauthorize this trade?`;
        this.$confirm(message,"Unauthorize","info",{confirmButtonText:"YES",cancelButtonText : "NO"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
              "bidWantedId": holding.id,
              "status" : 'WAITING_AUTHORIZATION',
              "cognitoSub":authService.getUser().cognitoSub,
              "highBidIds": holding.highBidId

          }
          this.$http
          .post(config.baseUrlBidSide + "/bidwanted/authorize",data,auth)
          .then(() => {
              this.loading = false; 
              this.getHoldingList();             
              // this.$alert("Holding has been successfully assigned to you.","","success")
          })
          .catch(() => {
              this.loading = false;              
          });
      })

    },
    filterHolding(){
      this.clearSelection();
      this.currentPage = 1;
      this.getHoldingList(true); 
    },
    searchHolding(){
      if(this.searchValue){
        if(this.searchValue.length < 9){
            this.currentPage = 1;
            this.getHoldingList(true); 
         // this.$alert("Please enter at least 9 characters to search.","","warning");
          return false;
        }
        //API to check account exist or not account/is-exist?search=BHT Method GET.
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/account/is-exist?search=" +
            this.searchValue,
            auth
        )
        .then(result => {
          console.log("result",result.data.message)

          if(result.data.message.trim() == "Account Not Exist"){
            this.currentPage = 1;
            this.getHoldingList(true); 
          }else{
            let selectedHoldings = Object.values(this.selectedHoldingsMap);
            // Ensure the newly selected holding belongs to the same account as the already selected ones.
            if(selectedHoldings.length > 0 && this.searchValue != selectedHoldings[0].bidWantedInventoryListDtoAccount[0].accountVal){
              this.clearSelection();
            }
            this.currentPage = 1;
            this.getHoldingList(true); 
          }
        }).catch(() => this.loading = false);
      }

      
    },
    clearSearch(){
      this.searchValue = "";
      this.currentPage = 1;
      this.getHoldingList(true); 
    },
    clearFilter(){
      this.filterStatus = [];
      this.getHoldingList(true);
    },
    getHoldingList(keepSelection){
      this.loading = true;
      console.log("getHoldingList",keepSelection)
        if(keepSelection !== true){
          this.clearSelection();
        }
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        let status = this.filterStatus.length == 0  ? this.statusList.map((e) => {return e.value}).toString() : this.filterStatus.map((e) => {return e.value}).toString();
        this.$http
        .get(
           config.baseUrlBidSide +
            "/bidwanted/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            status+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&traderCognitoSub="+
            authService.getUser().cognitoSub+
            "&accounts="+
            this.filterAccounts.toString(),
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          console.log("dd")

          result.data.content.forEach((data) => {
           data.highestBids = []
            if(data.bidWantedBids.length > 0){
              data.highestBids = data.bidWantedBids;
            }else{
              data.highestBids = []
            }
            const key = 'customerId';
            const accountKey = 'accountMapId'
            const customers = [...new Map(data.bidWantedInventoryListDto.map(item => [item[key], item])).values()];
            const accounts = [...new Map(data.bidWantedInventoryListDto.map(item => [item[accountKey], item])).values()];
            data.bidWantedInventoryListDtoCopy = customers;
            data.bidWantedInventoryListDtoAccount = accounts;
            
          });
          this.retainSelection(result.data.content);
          this.holdingsList = result.data.content;
          console.log(this.holdingsList)
          this.loading = false;
        }).catch(() => this.loading = false);
    },
    toggleViewBidWantedModalOpen(){
      this.viewBidWantedModalOpen = !this.viewBidWantedModalOpen;
      if(!this.viewBidWantedModalOpen){
        this.getHoldingList();
      }
    },
    toggleBringInBidWantedModal(holding){
      this.viewBringInModalOpen = !this.viewBringInModalOpen;
      if(!this.viewBringInModalOpen){
        this.getHoldingList();
      }else{
         holding.bidWantedInventoryListDtoCopy.forEach(customer => {
            holding.bidWantedInventoryListDto.forEach(cust => {
              if(customer.customerId == cust.customerId){
                cust.spread = customer.spread
              }
            });  
          })
        this.selectedHolding = {...holding};
      }
    },
     getAccountList(){
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/inventory/account-map-list",
            auth
        )
        .then((result) => {
          this.accountList = result.data.map(acc => acc.account);
        })
    },
  },
  mounted() {
    this.getAccountList();
    this.getHoldingList();

  }
};
</script>
<style scoped>
/* Keep all toolbar actions on a single row when a selection is active */
.abs-btn-grp,
.abs-btn-grp.col-sm-4 {
  max-width: min(80%, calc(100% - 60px));
  column-gap: 6px;
}

/* Compact selection indicator (replaces the bulky badge + full-width button) */
.selection-chip {
  display: inline-flex;
  align-items: center;
  height: 38px;
  padding: 0 4px 0 12px;
  background: #fff;
  border-radius: 5px;
  color: #303030;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.selection-chip__count {
  line-height: 1;
}
.selection-chip__clear {
  border: 0;
  background: transparent;
  color: #9aa0a6;
  cursor: pointer;
  padding: 6px 8px;
  margin-left: 2px;
  line-height: 1;
  border-radius: 4px;
  transition: color 0.15s ease, background 0.15s ease;
}
.selection-chip__clear:hover {
  color: #e53935;
  background: #f2f2f2;
}

.high-bid{
  padding: 4px;
}
.dropdown-item div {
   margin-top: -2px;
}
</style>
